import { render } from "./gallerySliderComponent.vue?vue&type=template&id=5f7af305&scoped=true"
import script from "./gallerySliderComponent.vue?vue&type=script&lang=js"
export * from "./gallerySliderComponent.vue?vue&type=script&lang=js"

import "./gallerySliderComponent.vue?vue&type=style&index=0&id=5f7af305&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7af305"]])

export default __exports__